<template>
    <flat-pickr v-model="inputVal" :config="config"></flat-pickr>
</template>

<script>
import { defineComponent } from "vue";
import flatPickr from 'vue-flatpickr-component';

export default defineComponent({
    props: {
        value: {
            required: true
        },
        config: {
            type: Object,
            required: false,
            default: () => {
                return {
                    enableTime: false,
                    dateFormat: "Y-m-d",
                }
            }
        }
    },
    components: {flatPickr},
    data() {
        return {
            inputVal: null
        }
    },
    mounted() {
        this.inputVal = this.value;
    }
});
</script>
